import s from './style.module.scss';
import { useState } from 'react';
import Switch from '../Switch';
import cx from 'classnames';
import { data } from '../mock';

function StrictlyNecessaryModal({ setDetailModal, permissions, setPermissions, permissionsRef }) {
  const [showDetail, setShowDetail] = useState();
  const dataKeyMap = data.afIntegrations.reduce((acc, item) => {
    acc[item.key] = item;
    return acc;
  }, {});
  const getDefaultPermission = () => {
    return permissions.advertising.default;
  };

  const handleToggle = (key, checked) => {
    const currentAdvertising = permissionsRef.current.advertising;
    const updatedAdvertising = { ...currentAdvertising, [key]: checked };
    setPermissions((prev) => ({ ...prev, advertising: updatedAdvertising }));
  };

  const handleBack = () => {
    if (showDetail) {
      setShowDetail(false);
    } else {
      setDetailModal(null);
    }
  };

  return (
    <>
      {showDetail ? (
        <>
          <>
            <div className={s.settings__title}>Name</div>
            <div className={s.settings__text}>{dataKeyMap[showDetail]?.name}</div>
            <div className={s.settings__title}>Description</div>
            <div className={s.settings__text}>{dataKeyMap[showDetail]?.description}</div>
            <div className={s.settings__title}>URL</div>
            <div className={s.settings__text}>
              <a href={dataKeyMap[showDetail]?.url}>{dataKeyMap[showDetail]?.url}</a>
            </div>
          </>
        </>
      ) : (
        <>
          <div className={s.settings__text}>
            You can toggle any Advertising Permissions on and off. We may add new partners from time to time. They will
            be added to this list. You can change your settings below at any time.
          </div>
          {Object.entries(permissions.advertising).map(([key, value]) => {
            if (key === 'default') {
              return null;
            }
            return (
              <div key={key} className={s.settings__item_1}>
                <div>
                  <div>Allow {dataKeyMap[key]?.name}</div>
                  <div className={s.button} onClick={() => setShowDetail(key)}>
                    View Details
                  </div>
                </div>
                <Switch checked={value} onChange={(checked) => handleToggle(key, checked)} />
              </div>
            );
          })}

          {/* new advertising perssion */}
          <div className={cx(s.settings__item_1, s.new)}>
            <div>
              <div>Allow new Advertising Permissions</div>
              <div className={s.button}>
                We may add new trackers. This setting determines whether these new trackers will be enabled or disabled
                by default.
              </div>
            </div>
            <Switch checked={getDefaultPermission()} onChange={(checked) => handleToggle('default', checked)} />
          </div>
        </>
      )}
      <div className={s.backArrow} onClick={handleBack}>
        <div className={s.arrow} />
      </div>
    </>
  );
}

export default StrictlyNecessaryModal;
